import { Box, Button, Card, CardContent, CircularProgress, Grid, TextField } from '@material-ui/core';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Alert from '@material-ui/lab/Alert';
import { Auth } from 'aws-amplify';
import { AuthPiece } from 'aws-amplify-react';
import React, { useState } from 'react';

import { useAuthStyles } from './styles';
import { useFormFields } from '../../../lib/hooks.lib';
import { ApplicationFormContainer } from '../../../private/pages/ApplicationsForm/applications-form.styles';

interface CustomSignInProps {
  authState?: string;
  [key: string]: unknown;
}

export const CustomSignIn = (props: CustomSignInProps): JSX.Element => {
  const classes = useAuthStyles();
  const authPiece = new AuthPiece(props);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [fields, handleFieldChange] = useFormFields({
    username: '',
    password: ''
  });

  const handleSignIn = async (event: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>): Promise<void> => {
    event.preventDefault();
    setLoading(true);
    try {
      const user = await Auth.signIn(fields.username, fields.password);
      authPiece.changeState('confirmSignIn', user);
      setErrorMessage(undefined);
      setLoading(false);
    } catch (error) {
      console.log(error);
      const errorCode = error && typeof error === 'object' && 'code' in error ? String((error as { code?: unknown }).code) : undefined;
      const message = error instanceof Error ? error.message : String(error);

      if (errorCode === 'UserNotConfirmedException') {
        authPiece.changeState('confirmSignUp', { username: fields.username });
      } else if (errorCode === 'PasswordResetRequiredException') {
        authPiece.changeState('forgotPassword', fields.username);
      }
      setErrorMessage(message);
      setLoading(false);
    }
  };

  const checkFormFilled = () => {
    return Object.values(fields).every(Boolean);
  };

  const renderSignIn = () => (
    <ApplicationFormContainer>
      <Box ml={4} mr={4} mb={3}>
        {errorMessage && (
          <Alert
            severity="error"
            onClose={() => {
              setErrorMessage(undefined);
            }}
          >
            {errorMessage}
          </Alert>
        )}
        <Grid container justifyContent="center">
          <Grid item>
            <Typography variant="h4">Sign In</Typography>
            <Typography variant="body1">
              Sign in below or create an account to start a Texas Match the Promise Foundation℠ scholarship application.
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box pt={3} mb={3}>
        <Grid container justifyContent="center" spacing={2}>
          <Grid item xs={10} sm={5}>
            <Card>
              <CardContent>
                <div className="ChangePassword">
                  <form>
                    <Grid container justifyContent="space-between" spacing={2}>
                      <Grid item xs={12}>
                        <TextField
                          required
                          id="username"
                          name="username"
                          label="Username"
                          type="text"
                          fullWidth
                          value={fields.username}
                          onChange={handleFieldChange}
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <TextField
                          required
                          id="password"
                          name="password"
                          label="Password"
                          type="password"
                          fullWidth
                          value={fields.password}
                          onChange={handleFieldChange}
                        />
                      </Grid>
                    </Grid>
                    <Link
                      component="button"
                      type="button"
                      onClick={() => {
                        authPiece.changeState('forgotPassword');
                        setErrorMessage(undefined);
                      }}
                      variant="body2"
                      style={{ float: 'right' }}
                    >
                      Forgot password?
                    </Link>
                    <Grid container justifyContent="center">
                      <Grid item style={{ marginTop: '20px' }}>
                        <Button
                          variant="contained"
                          type="submit"
                          color="primary"
                          className={classes.button}
                          disabled={!checkFormFilled()}
                          onClick={(e) => handleSignIn(e)}
                        >
                          Log In
                          {loading && (
                            <Box ml={2} mt={1}>
                              <CircularProgress size="0.8rem" color={'inherit'} />
                            </Box>
                          )}
                        </Button>
                      </Grid>
                    </Grid>
                    <Grid container justifyContent="center" spacing={2}>
                      <Grid item xs={12} sm={6} style={{ marginTop: '50px' }}>
                        <Link
                          component="button"
                          type="button"
                          onClick={() => {
                            authPiece.changeState('signUp');
                            setErrorMessage(undefined);
                          }}
                          variant="body2"
                        >
                          Create account
                        </Link>
                      </Grid>
                      <Grid item xs={12} sm={6} style={{ marginTop: '50px', textAlign: 'right' }}>
                        <Link
                          component="button"
                          type="button"
                          onClick={() => {
                            authPiece.changeState('confirmSignUp');
                            setErrorMessage(undefined);
                          }}
                          variant="body2"
                        >
                          Confirm account
                        </Link>
                      </Grid>
                    </Grid>
                  </form>
                </div>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </ApplicationFormContainer>
  );

  return <div>{props.authState === 'signIn' && renderSignIn()}</div>;
};
